import { User } from './user'

export enum CallJoinableMode {
  Anyone = 'anyone',
  Users = 'users',
  FollowersOnly = 'followers_only',
  InviteOnly = 'invite_only',
  MutualFollowsOnly = 'mutual_follows_only',
  Noone = 'noone',
}

export enum GroupCallJoinableMode {
  Users = 'users',
  InviteOnly = 'invite_only',
  Noone = 'noone',
}

export enum CallType {
  Video = 'vdo',
  Call = 'call',
  Voice = 'voice',
}

export type CallUserRole = 'participant' | 'moderator' | 'host'

export type ConferenceCall = {
  id: number
  active: boolean
  conference_call_users_count: number
  call_type: CallType
  server: string
  mode: 'individual_call' | 'call' | null
  agora_channel: string
  anonymous_call_users_count: number
  joinable_by: CallJoinableMode | GroupCallJoinableMode
  max_participants: number
  bump_params: { participant_limit: number }
  group_id: null
  post_id: number
  host_id: number
  agora_token: string
  users: Record<string, User & { id: string; role: CallUserRole }>
  conference_call_users: Partial<User>[]
  conference_call_user_roles: ConferenceCallUserRole[]
  game: any
  genre: any
  locked: boolean
  open: boolean
}

export type ConferenceCallUserRole = {
  id: number
  user_id: number
  role: CallUserRole
}

export type CallActionSignature = {
  action: string
  call_id: number
  sender_uuid: string
  receiver_uuid: string
  timestamp: number
  signature: string
}
